import { STATUS_LABEL, STATUS_CLASS } from "../templates.js";
import { t, statusLabel } from "../i18n.jsx";

export function formatBytes(bytes) {
  if (bytes === null || bytes === undefined) return "—";
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB"];
  let value = bytes / 1024;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i += 1;
  }
  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[i]}`;
}

export function Field({ label, children, hint }) {
  return (
    <div className="field">
      <label>{label}</label>
      {children}
      {hint && <div style={{ color: "var(--ink-dim)", fontSize: "0.78rem" }}>{hint}</div>}
    </div>
  );
}

export function StatusBadge({ status, lang }) {
  return <span className={`status-badge ${STATUS_CLASS[status] || ""}`}>{statusLabel(status, lang, STATUS_LABEL)}</span>;
}

export function AlertBadge({ alert, zileRamase, lang }) {
  if (!alert) return null;
  const text = alert === "EXPIRAT"
    ? (lang === "en" ? `Review overdue (${Math.abs(zileRamase)} days)` : `Revizuire expirată (${Math.abs(zileRamase)} zile)`)
    : (lang === "en" ? `Review due in ${zileRamase} days` : `Revizuire în ${zileRamase} zile`);
  return <span className={`alert-badge alert-${alert}`}>{text}</span>;
}

export function Modal({ title, onClose, children, width = 560 }) {
  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex",
        alignItems: "flex-start", justifyContent: "center", padding: "4em 1em", zIndex: 100, overflowY: "auto",
      }}
      onClick={onClose}
    >
      <div className="card" style={{ width: "100%", maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1em" }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ListEditor({ value, onChange, placeholder, lang }) {
  const items = value || [];
  function update(i, v) {
    const next = [...items];
    next[i] = v;
    onChange(next);
  }
  function remove(i) {
    onChange(items.filter((_, idx) => idx !== i));
  }
  return (
    <div>
      {items.map((item, i) => (
        <div className="list-input-row" key={i}>
          <input value={item} placeholder={placeholder} onChange={(e) => update(i, e.target.value)} />
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => remove(i)}>✕</button>
        </div>
      ))}
      <button type="button" className="btn btn-sm" onClick={() => onChange([...items, ""])}>{t(lang, "+ Adaugă")}</button>
    </div>
  );
}
